<template>
  <div class="app-container">
    <PageTitle title="项目列表" ref="pageTitle" v-model="listQuery.city" @onChange="changeCity" />
    <div class="filter-container" style="justify-content: start">
      <el-select
        clearable
        v-model="id"
        filterable
        placeholder="请选择项目名称"
        style="width: 200px; margin-right: 10px; height: 32px"
        @change="changeProject"
      >
        <el-option
          v-for="item in project_options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>

      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="$refs.edit.handleCreate()"
        >添加项目</el-button
      >
    </div>
    <Table :data="list" :columns="columns" :loading="listLoading">
      <template v-slot:service_duration>
        <el-table-column label="服务时长" width="110" align="center">
          <template slot-scope="scope"> {{ scope.row.service_duration }}分钟 </template>
        </el-table-column>
      </template>
      <template v-slot:add_time>
        <el-table-column label="添加时间" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="success" :underline="false">{{ scope.row.add_time }}</el-link>
          </template>
        </el-table-column>
      </template>

      <template v-slot:is_need_card>
        <el-table-column label="是否需要证件" width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.is_need_card ? '是' : '否' }}
          </template>
        </el-table-column>
      </template>

      <template v-slot:action>
        <el-table-column label="操作" minWidth="120">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="$refs.edit.handleEdit(scope.row.id)"
            />
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              @click="handleDel(scope.row.id)"
            />
          </template>
        </el-table-column>
      </template>
    </Table>
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
    <Edit ref="edit" />
  </div>
</template>

<script>
import { getList, del } from '@/api/projects'
import { getList as getProjectList } from '@/api/projects'
import PageTitle from '@/components/PageTitle'
import Edit from './components/Edit'
export default {
  name: 'ProjectsIndex',
  components: {
    PageTitle,
    Edit
  },
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        city: '',
        id: ''
      },
      project_options: [],
      columns: [
        {
          type: 'index',
          align: 'center',
          label: '序号',
          width: '50'
        },
        {
          label: '项目ID',
          width: '120',
          align: 'center',
          prop: 'id'
        },
        {
          label: '项目名称',
          width: '200',
          prop: 'name',
          showOverflowTooltip: true
        },
        {
          label: '汇合地点',
          width: '200',
          prop: 'location_detail',
          showOverflowTooltip: true
        },
        {
          label: '服务时长',
          slot: 'service_duration'
        },
        {
          label: '团队人数上限',
          width: '120',
          prop: 'user_limit',
          align: 'center'
        },
        {
          label: '是否需要证件',
          slot: 'is_need_card'
        },
        {
          label: '添加时间',
          slot: 'add_time'
        },
        {
          label: '操作',
          slot: 'action'
        }
      ]
    }
  },
  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
    this.fetchData()
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true
      getList(this.listQuery).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        this.listLoading = false
      })
    },
    /**
     * @description: 选择项目名称
     * @param {*} e
     * @return {*}
     */
    changeProject(value) {
      // let list = this.project_options.filter((item) => item.id === value)
      this.listQuery.id = value
      this.handleFilter()
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        city: 1,
        id: ''
      }
      this.fetchData()
    },
    /**
     * @description: 选择城市
     * @param {*} e
     * @return {*}
     */
    changeCity(e) {
      this.listQuery.city = e
      this.fetchData()
    },
    // 删除
    handleDel(uuid) {
      this.$confirm('是否确认删除此项目？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          del(uuid).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
